import customerReducer from '@sophocles/features/customers/slice';

export default customerReducer;
export { customerReducer };
